import type { IconProps } from '@peacecover/icon';

const GradientArrowRight = ({ size = 24, className, ...props }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path
      d="M7.70618 4.9362C7.64085 5.0026 7.58899 5.08159 7.55361 5.16862C7.51822 5.25565 7.5 5.349 7.5 5.44329C7.5 5.53757 7.51822 5.63092 7.55361 5.71795C7.58899 5.80499 7.64085 5.88398 7.70618 5.95037L10.8986 9.22143C10.964 9.28782 11.0158 9.36682 11.0512 9.45385C11.0866 9.54088 11.1048 9.63423 11.1048 9.72852C11.1048 9.8228 11.0866 9.91615 11.0512 10.0032C11.0158 10.0902 10.964 10.1692 10.8986 10.2356L7.70618 13.5067C7.64085 13.5731 7.589 13.652 7.55361 13.7391C7.51822 13.8261 7.5 13.9195 7.5 14.0137C7.5 14.108 7.51822 14.2014 7.55361 14.2884C7.589 14.3754 7.64085 14.4544 7.70618 14.5208C7.83678 14.6539 8.01345 14.7285 8.1976 14.7285C8.38175 14.7285 8.55841 14.6539 8.68901 14.5208L11.8884 11.2426C12.28 10.8409 12.5 10.2963 12.5 9.72852C12.5 9.16072 12.28 8.61614 11.8884 8.2144L8.68901 4.9362C8.55841 4.80318 8.38175 4.72852 8.1976 4.72852C8.01345 4.72852 7.83678 4.80318 7.70618 4.9362Z"
      fill="url(#paint0_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="7.5"
        y1="14.7285"
        x2="7.66572"
        y2="4.64904"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#458FFF" />
        <stop offset="1" stopColor="#CF6AFF" />
      </linearGradient>
    </defs>
  </svg>
);

export default GradientArrowRight;
